// import React from 'react'
import LucaModalProgramados from '../components/LucaModalProgramados'
import FacturaPreviewPDF from '../../../../../../table/typesExportPDF/FacturaPreviewPDF'
// import { Menu, ZoomIn, ZoomOut, RotateCcw, Download, Printer } from 'lucide-react'

const calculateNextEmission = (row) => {
  if (!row) return ''
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  let anchorDate = new Date(today)
  if (row.fecha_inicio) {
    const parts = row.fecha_inicio.split('-')
    if (parts.length === 3) {
      const parsedDate = new Date(parts[0], parts[1] - 1, parts[2])
      if (parsedDate > anchorDate) anchorDate = parsedDate
    }
  }
  const diaMes = row.dia_del_mes || 15
  const jsTargetDay = row.dia_de_semana === 7 ? 0 : (row.dia_de_semana || 1)
  const applyFrequencyJump = (date, freq) => {
    if (freq === 'monthly') date.setMonth(date.getMonth() + 1)
    else if (freq === 'quarterly') date.setMonth(date.getMonth() + 3)
    else if (freq === 'semiannual' || freq === 'biannual') date.setMonth(date.getMonth() + 6)
    else if (freq === 'yearly') date.setFullYear(date.getFullYear() + 1)
  }
  let finalDate = new Date(anchorDate)
  if (['monthly', 'quarterly', 'semiannual', 'biannual', 'yearly'].includes(row.frecuencia)) {
    finalDate = new Date(anchorDate.getFullYear(), anchorDate.getMonth(), diaMes)
    if (finalDate < anchorDate) {
      applyFrequencyJump(finalDate, row.frecuencia)
    }
  } else if (row.frecuencia === 'weekly') {
    let currentDay = finalDate.getDay()
    let daysToAdd = jsTargetDay - currentDay
    if (daysToAdd < 0) daysToAdd += 7
    finalDate.setDate(finalDate.getDate() + daysToAdd)
  }
  const dd = String(finalDate.getDate()).padStart(2, '0')
  const mm = String(finalDate.getMonth() + 1).padStart(2, '0')
  const yyyy = finalDate.getFullYear()
  return `${dd}-${mm}-${yyyy}`
}

export default function ModalVistaPreviaPDFProgramado({ open, onClose, row, masterEntityData }) {
  if (!row) return null

  // Map row and masterEntityData into the format expected by FacturaPreviewPDF
  const mappedDocument = {
    document_issuer: {
      rut: masterEntityData?.tax_id || '',
      business_name: masterEntityData?.name || '',
      business_activity: masterEntityData?.activities?.[0]?.name || '',
      address: masterEntityData?.addresses?.[0]?.address || '',
      district: masterEntityData?.addresses?.[0]?.district?.name || '',
      city: masterEntityData?.addresses?.[0]?.district?.city?.name || ''
    },
    document_receiver: {
      rut: row.rut_receptor || '',
      business_name: row.business_name || '',
      business_activity: 'Sin actividad económica', // placeholder if not present
      address: row.address || '',
      district: row.district || '',
      city: row.city || ''
    },
    dte_type: { code: String(row.tipo_documento || '33') },
    date_issued: calculateNextEmission(row),
    details: row.details || [],
    header: { payment_method: 2 } // Credito
  }

  return (
    <LucaModalProgramados
      open={open}
      onClose={onClose}
      maxWidth="max-w-4xl"
    >
      <div className="flex-1 flex flex-col min-h-0">
        <div className='flex-1 overflow-y-auto bg-slate-100 p-6 custom-scrollbar flex justify-center items-start'>
          <div className="bg-white shadow-2xl relative w-full flex justify-center" style={{ maxWidth: '820px' }}>
            <FacturaPreviewPDF document={mappedDocument} currentBusiness={mappedDocument.document_issuer} />
          </div>
        </div>
      </div>
    </LucaModalProgramados>
  )
}
